import { DEFAULT_EVENT_DURATION_MS, ICS_PRODID, ICS_UID_DOMAIN } from './constants';

const LINE_BREAK = '\r\n';
const FOLD_LENGTH = 73;

export const formatIcsDate = (ms) =>
  new Date(Number(ms))
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}/, '');

export const escapeIcsText = (value) =>
  String(value ?? '')
    .replace(/\\/g, '\\\\')
    .replace(/\r?\n/g, '\\n')
    .replace(/;/g, ';')
    .replace(/,/g, '\\,');

export const foldIcsLine = (line) => {
  if (line.length <= FOLD_LENGTH + 2) {
    return line;
  }
  const chunks = [line.slice(0, FOLD_LENGTH + 2)];
  for (let index = FOLD_LENGTH + 2; index < line.length; index += FOLD_LENGTH) {
    chunks.push(` ${line.slice(index, index + FOLD_LENGTH)}`);
  }
  return chunks.join(LINE_BREAK);
};

export const buildIcs = (event, { nowMs = Date.now(), url = '' } = {}) => {
  const startsAtMs = Number(event?.startsAtMs);
  const endsAtMs =
    Number(event?.endsAtMs) > startsAtMs
      ? Number(event.endsAtMs)
      : startsAtMs + DEFAULT_EVENT_DURATION_MS;

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    `PRODID:${ICS_PRODID}`,
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${event?.eventId}@${ICS_UID_DOMAIN}`,
    `DTSTAMP:${formatIcsDate(nowMs)}`,
    `DTSTART:${formatIcsDate(startsAtMs)}`,
    `DTEND:${formatIcsDate(endsAtMs)}`,
    `SUMMARY:${escapeIcsText(event?.title)}`,
  ];
  if (event?.description) {
    lines.push(`DESCRIPTION:${escapeIcsText(event.description)}`);
  }
  if (event?.location) {
    lines.push(`LOCATION:${escapeIcsText(event.location)}`);
  }
  if (url) {
    lines.push(`URL:${url}`);
  }
  lines.push('END:VEVENT', 'END:VCALENDAR');

  return `${lines.map(foldIcsLine).join(LINE_BREAK)}${LINE_BREAK}`;
};

export const buildIcsFileName = (event) => {
  const slug = String(event?.title || 'event')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${slug || 'event'}.ics`;
};
